import { jsx as _jsx } from "react/jsx-runtime";
import { useMove_TopicsQuery, useTopic_TocQuery } from "sprout-graphql";
import { useMoveItemsDialog } from "./MoveItemsDialogContext";
import MoveItemsDialogLoader from "./MoveItemsDialog_Loader";
import MoveItemsDialogTopics from "./MoveItemsDialog_Topics";
const MoveItemsDialogQuery = (props)=>{
    var ref;
    const { onRequestClose , onSuccess  } = props;
    const { currentTopicId  } = useMoveItemsDialog();
    const { loading: treeLoading , data: treeQueryData  } = useTopic_TocQuery({
        variables: {
            topicId: Number(currentTopicId)
        },
        fetchPolicy: "cache-and-network",
        skip: !currentTopicId
    });
    const { loading: topicsLoading , data: topicsQueryData  } = useMove_TopicsQuery({
        fetchPolicy: "cache-and-network"
    });
    if (treeLoading || topicsLoading) return /*#__PURE__*/ _jsx(MoveItemsDialogLoader, {});
    const rootTopicOrSelf = (treeQueryData === null || treeQueryData === void 0 ? void 0 : (ref = treeQueryData.topic) === null || ref === void 0 ? void 0 : ref.rootTopicOrSelf) || undefined;
    return /*#__PURE__*/ _jsx(MoveItemsDialogTopics, {
        topicTree: rootTopicOrSelf,
        topicsQueryData: topicsQueryData,
        onRequestClose: onRequestClose,
        onSuccess: onSuccess
    });
};
export default MoveItemsDialogQuery;
